<template> <!-- we can use functional component -->
  <div>
    <div class="wrapper wrapper-content animated fadeInRight">
	<div class="row">
		<div class="col-lg-12">
			<div class="ibox float-e-margins">
				<div class="ibox-title">
          <h4 v-if="item">
            Mail to Fax Address settings:
          </h4>
				</div>
				<div class="ibox-content">

					<div class="row">
						<div class="enswitch-form-container col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<form name="editCRMUserForm" novalidate="" class="" @submit.prevent="save()" v-if="!loading">
							** Email Address can be : Domain (@example.com) / Email Address (me@example.com).
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-fill cursore" viewBox="0 0 16 16" v-on:click="showExample">
								<path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
								<path fill-rule="evenodd" d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
								</svg>
								<div class="row form-group">
									<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label">Email Address:</span>
									<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
										<input name="name" caption="name" v-model="item.source" type="name" />
									</div>
								</div>

								<div class="row form-group">
									<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label">Description:</span>
									<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
										<input name="description" caption="description" v-model="item.description" type="text" />
									</div>
								</div>
								<!---->

								<hr>
								<div class="row submit-button-container">
									<button type="submit" :disabled="sendInProgress" ref="submitbtn" class="btn btn-success confirm-button ladda-button edit-person-confirm vueadapt" data-style="zoom-out" data-spinner-size="24" data-size="s" data-spinner-color="white" style="display: block;">
										<span class="ladda-label">Save</span>
										<span class="fas fa-spinner fa-pulse"></span>
										<div class="ladda-progress" style="width: 0px"></div>

									</button>
								</div>
							</form>
						</div>
					</div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ng-scope" style="margin-bottom: 8px;" ng-if="options.showProgress">
            <div v-if="loading" class="sk-spinner sk-spinner-wave ng-scope" ng-if="options.showProgress" style="display: block;">
              <div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div><!-- end ngIf: options.showProgress --></div><!-- end ngIf: options.showProgress -->
          </div>
		</div>
		</div>
	</div>
</div>
  </div>
</template>

<script>
import {MailToFaxService} from "../../services/MailToFaxService";

export default {
	props: ["id", "isNew"],
	data: () => ({loading: false, item: {}, sendInProgress: false, openList: false, phones: [], people: [], person: {role: 4, email: null}}),
	created() {
		let $injector = this.$root.angularInjector;

		let CoreApiService = $injector.get("CoreApiService");

		this.mailToFaxService = new MailToFaxService(CoreApiService);

		this.phonesService = $injector.get("PhonesApiService");
		this.SwalService = $injector.get("SwalService");

		if (this.isNew) {
			this.item = {ignore_missing_spf: 0};
		}
	},
	async mounted() {
		let promises = [];
		this.loading = true;
		if (!this.isNew) {
			// let phones = await this.phonesService.getPhonesList();
			promises.push(this.loadItemToEdit());
		}
		// else {
		// 	promises.push(this.loadPeopleList())
		// }
		// promises.push(this.loadPhones());
		await Promise.all(promises);
		this.loading = false;
	},
	watch: {
		sendInProgress: function(val) {
			if (val) {
				this.$refs.submitbtn.dataset.loading = "";
			}
			else {
				delete this.$refs.submitbtn.dataset.loading;
			}
		}
	},
	methods: {
		showExample() {
			// this.SwalService.popup({
			// 	type: "info",
			// 	title: "example",
			// 	html: '<img src="" width="400" height="500">'
			// });
		},
		isValidEmailAddress() {
			return this.item.source && this.item.source.indexOf("@") >= 0 && this.item.source.split("@")[1].indexOf(".") > 0;
		},
		async loadItemToEdit() {
			this.sourceItem = await this.mailToFaxService.get(this.id);
			this.item = Object.assign({}, this.sourceItem);
			delete this.item.id;
		},
		async loadPhones() {
			let response = await this.phonesService.getPhonesList();
			console.info("phones response", response);
			this.phones = response.data;
		},
		async save() {
			// let result;
			this.sendInProgress = true;
			try {
				const messagePrefix = this.item.source[0] === "@" ? "" : " of this email address";
				if (!this.isValidEmailAddress()) {
					throw new Error("This email address is invalid.");
				}
				const isSPF = await this.mailToFaxService.checkSPF(this.item);
				if (!isSPF.data.hasRecords) {
					await this.SwalService.popup({
						type: "question",
						text: "The domain" + messagePrefix + " does not have SPF record. Maybe you mistyped it.\n Are you sure you want to create it anyway?",
						showCancelButton: true,
						showCloseButton: true,
						showLoaderOnConfirm: true,
						closeOnConfirm: true
					}).then((result) => {
						if (result) {
							this.item.ignore_missing_spf = 1;
						}
					});
				}
				if (this.isNew) {
					await this.mailToFaxService.create(this.item);
				}
				else {
					await this.mailToFaxService.update(this.sourceItem.id, this.item);
				}
				this.SwalService.popup({
					title: "Success!"
				}).then(f => {
					this.$router.replace("/list");
				});
			}
			catch (e) {
				this.SwalService.popup({
					title: getErrorMessage(e), type: "error"
				});
			}
			finally {
				this.sendInProgress = false;
			}
		}
	}
};

function getErrorMessage(e) {
	if (e.message === "Bad request") {
		if (e.key === "error_username_in_use") {
			return "Duplicate username";
		}
		else if (e.key === "error_email_exists") {
			return "Duplicate email";
		}
	}
	return e.message || e.statusText || e || "Error";
}
</script>

<style>
.cursore:hover{
 cursor: pointer;
 }
</style>
